import React, { ComponentProps } from 'react';
import { ContentImage } from '../../../types/api/ImageType';
import { asView, useViewContext } from '../../../_lib/ViewFetcher';
import { Image } from '../../../components/molecules/Image';
import { useLayoutGroupContext } from '../../../components/blocks/LayoutGroup/LayoutGroup';
import { useAppContext } from '../../../contexts/AppContext/AppContext';

type ContentImageDefaultProps = {
  image?: ContentImage;
};
export function ContentImageDefault({ image }: ContentImageDefaultProps) {
  const { fetchUrl } = useViewContext();
  // only image block in contentwrapper that can be connected.
  // groupLayout info from contentwrapper is required, but not in edit mode, only in live
  const groupLayout = useLayoutGroupContext();
  const { editModeInfo } = useAppContext();

  if (!image) {
    return null;
  }

  return (
    <Image
      key={image.src}
      image={image}
      responsiveType="contentImage"
      lazyLoading
      fetchUrl={fetchUrl}
      groupLayout={editModeInfo.active ? undefined : groupLayout}
    />
  );
}
export const ContentImageDefaultView = asView(ContentImageDefault);
export type ContentImageDefaultView = ComponentProps<typeof ContentImageDefaultView>;
